<template>
  <div>
    <h2>{{ user.first_name }} {{ user.last_name }}</h2>

    <hr v-if="user.first_name || user.employer_name">

    <div class="row my-4">
      <div class="col-lg-6 pr-5">
        <div class="input-group" style="max-width: 450px;">
          <select class="form-control" v-model="status">
            <option v-for="(statusOption, index) in statuses" :key="index">{{ statusOption }}</option>
          </select>
          <button class="btn btn-secondary" @click="updateStatus()">Update Status</button>
        </div>
      </div>
      <!-- <div class="col-lg-6 px-4">
        <div class="input-group">
          <multiselect v-model="tags" :options="tagsOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Select Tags"></multiselect>
          <button class="btn btn-secondary" @click="updateTags()" style="">Update Tags</button>
        </div>
      </div> -->
    </div>
    <hr>
    <interview-scheduler :user="user"></interview-scheduler>
    <hr>

    <div class="row my-4">
      <div class="col-lg-6 px-4">
        <h3>Notes</h3>
        <hr>
        <!-- {{ notes }} -->
        <div v-for="note in notes" :key="note.id">
          <!-- {{ note.note }} -->
          <pre @click="showEditNoteModal(note)" style="cursor: pointer;">{{ note.note }}</pre>
          <small style="">{{ (new Date(note.timestamp)).toDateString() }}<span v-if="note.type"> ({{ note.type }})</span></small>
          <hr>
        </div>
        <!-- <hr> -->
        <button class="mylisting-button dark-button" @click="showAddNoteModal()">Add Note</button>
      </div>
      <div class="col-lg-6 px-4">
        <p class="mb-1">Registration Date: {{ new Date(user.created_date).toDateString() }}</p>
        <p class="mb-3">Last Contacted Date: {{ new Date(user.last_contacted_date).toDateString() }}</p>
        <h3>Send Email</h3>
        <p class="mb-2">{{ user.email }}</p>
        <label style="margin-bottom: 0;">From Email</label>
        <!-- <input type="text" class="form-control mb-2" v-model="fromEmail" placeholder="From Email"> -->
        <multiselect
          class="mb-2 w-100"
          v-model="fromEmail"
          :options="$store.getters.agencyAdminEmails"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder=""
          :max-height= "150"
        ></multiselect>
        <input type="text" class="form-control mb-2" v-model="emailSubject" placeholder="Subject">
        <textarea class="form-control" rows="5" v-model="emailMessage"></textarea>
        <!-- <pre>{{ emailMessage }}</pre> -->

        <div class="form-group form-check mb-1 mt-1">
          <input class="form-check-input" type="checkbox" :value="true" v-model="logMessage" style="">
          <label class="form-check-label" style="text-align: left; cursor: pointer;" @click="logMessage = !logMessage">
            Log email as note
          </label>
        </div>
        <button class="mylisting-button dark-button" style="" @click="sendEmail()">Send</button>
        <!-- <div v-if="user.phone">
          <h3 class="mt-5">Send SMS</h3>
          <p class="mb-2">{{ user.phone }}</p>
          <textarea class="form-control" rows="3" v-model="textMessage"></textarea>
          <div class="form-group form-check mb-1 mt-1">
            <input class="form-check-input" type="checkbox" :value="true" v-model="logMessage" style="">
            <label class="form-check-label" style="text-align: left; cursor: pointer;" @click="logMessage = !logMessage">
              Log SMS as note
            </label>
          </div>
          <button class="mylisting-button dark-button" style="" @click="sendSMS()">Send</button>
        </div> -->

      </div>
    </div>

    <hr>
    <!-- <button class="mylisting-button dark-button" @click="updatePassword()">Update Password</button> -->
    <!-- <button class="mylisting-button dark-button" @click="showAddNoteModal()">Update Password</button> -->
    <div class="input-group" style="max-width: 450px;">
      <input class="form-control" v-model="password">
      <button class="btn btn-secondary" @click="updatePassword()">Update Password</button>
    </div>

    <modal name="note-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2 v-if="!note.id">Add Note</h2>
        <h2 v-if="note.id">Edit Note</h2>
        <hr>
        <textarea class="form-control" rows="5" v-model="noteText"></textarea>
        <hr>
        <button class="mylisting-button secondary-button" @click="hideNoteModal()" style="">Cancel</button>
        <button v-if="note.id" class="mylisting-button danger-button" @click="deleteNote()" style="">Delete Note</button>
        <!-- <button class="mylisting-button dark-button" @click="resetPassword(user)" style="">Reset Password</button> -->
        <!-- <button class="btn btn-danger" @click="deleteUser(user)">Delete</button> -->
        <!-- <button v-if="user.status != 'Active'" class="mylisting-button dark-button" @click="approveUser(user)" style="float: right;">Activate</button> -->
        <button v-if="!note.id" class="mylisting-button dark-button" @click="addNote()" style="float: right;">Add Note</button>
        <button v-if="note.id" class="mylisting-button dark-button" @click="updateNote()" style="float: right;">Update Note</button>
        <!-- <button class="mylisting-button danger-button" @click="deleteUser(user)">Delete</button> -->

      </div>
    </modal>

    <modal name="message-sent-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Message sent.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('message-sent-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="status-updated-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Status updated.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('status-updated-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="password-reset-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Password reset to {{ this.password }}</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('password-reset-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

import InterviewScheduler from './functions/InterviewScheduler'

export default {
  props: ['passedUser'],
  components: {
    InterviewScheduler,
  },
  data() {
    return {
      agency: {},

      user: {},
      status: '',
      statuses: [],
      tags: [],
      tagsOptions: [],

      notes: [],
      note: {},
      noteText: '',
      noteType: '',

      fromEmail: '',
      emailSubject: "",
      emailMessage: "",
      textMessage: "",
      logMessage: true,

      password: '',
    }
  },
  created() {
    this.user = this.passedUser

    if (this.user.is_candidate) {
      this.statuses = this.$store.getters.candidateStatuses
      // this.fromEmail = this.$store.getters.agencyFromEmail
      this.fromEmail = this.$store.getters.agencyAdminEmail2
    }

    if (this.user.is_employer) {
      this.statuses = this.$store.getters.employerStatuses
      this.fromEmail = this.$store.getters.agencyFromEmail
    }

    this.getNotes()
    // this.fromEmail = this.$store.getters.agencyFromEmail
    this.status = this.user.status
    this.tagsOptions = this.$store.getters.focusAreas
    this.tags = this.user.sectors

    this.getAgency()
  },
  methods: {
    getAgency() {
      // axios.get()
    },
    updateTags() {
      axios.patch('/api/people/'+this.user.id+'/', {
        sectors: this.tags
      })
        .then(res => {
          this.user.sectors = this.tags
          this.$emit('userUpdated') // Lecture 112
        })
    },
    getNotes() {
      axios.get('/api/notes?user='+this.user.id)
        .then(res => {
          this.notes = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showAddNoteModal() {
      this.note = {}
      this.noteText = ''
      this.$modal.show('note-modal')
    },
    showEditNoteModal(note) {
      this.note = note
      this.noteText = note.note
      this.$modal.show('note-modal')
    },
    hideNoteModal() {
      this.note = {}
      this.noteText = ''
      this.$modal.hide('note-modal')
    },
    addNote() {
      console.log(this.user.id)
      console.log(this.$store.getters.userID)
      console.log(this.noteText)
      console.log(this.$store.getters.agencyName)
      console.log(this.$store.getters.agencyID)

      axios.post('/api/notes/', {
        user: this.user.id,
        enterer: this.$store.getters.userID,
        note: this.noteText,
        type: this.noteType,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          console.log(res)
          this.hideNoteModal()
          this.getNotes()
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateNote() {
      axios.patch('/api/notes/'+this.note.id+'/', {
        note: this.noteText,
      })
        .then(res => {
          console.log(res)
          this.hideNoteModal()
          this.getNotes()
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteNote() {
      axios.delete('/api/notes/'+this.note.id+'/')
        .then(res => {
          console.log(res)
          this.hideNoteModal()
          this.getNotes()
        })
        .catch(error => {
          console.log(error)
        })
    },
    sendEmail() {
      this.$modal.show('message-sent-modal')

      this.$store.dispatch('sendEmails',
        {
          subject: this.emailSubject,
          message: this.emailMessage,
          from: this.fromEmail,
          emails: [this.$store.getters.enginehireLoggingEmail, this.user.email],
          reply: this.fromEmail,
          userID: this.user.id,
        }
      )
      this.user.last_contacted_date = new Date()
      if (this.logMessage) {
        this.noteType = 'Email'
        this.noteText = 'Subject: ' + this.emailSubject + '\n\n' + this.emailMessage
        this.addNote()
        this.emailSubject = ''
        this.emailMessage = ''
      }
      else {
        this.emailSubject = ''
        this.emailMessage = ''
      }

      // axios
      //   .post("/optimum/email/", {
      //     subject: this.emailSubject,
      //     message: this.emailMessage,
      //     from_address: this.fromEmail,
      //     to_address: this.user.email,
      //     reply_address: this.fromEmail,
      //     user_id: this.user.id
      //   })
      //   .then(res => {
      //     console.log(res);
      //     this.user.last_contacted_date = new Date()

      //     if (this.logMessage) {
      //       this.noteType = 'Email'
      //       this.noteText = 'Subject: ' + this.emailSubject + '\n\n' + this.emailMessage
      //       this.addNote()
      //       this.emailSubject = ''
      //       this.emailMessage = ''
      //     }
      //     else {
      //       this.emailSubject = ''
      //       this.emailMessage = ''
      //     }
      //   })
      //   .catch(error => console.log(error));
    },
    sendSMS() {
      this.$modal.show('message-sent-modal')

      axios
        .post("/optimum/message/", {
          message: this.textMessage,
          phone: this.user.phone,
          user_id: this.user.id
        })
        .then(res => {
          console.log(res);
          this.user.last_contacted_date = new Date()

          if (this.logMessage) {
            this.noteType = 'SMS'
            this.noteText = this.textMessage
            this.addNote()
            this.textMessage = ''
          }
          else {
            this.textMessage = ''
          }
        })
        .catch(error => console.log(error));
    },
    updateStatus() {
      axios.patch('/api/people/'+this.user.id+'/', {
        status: this.status
      })
        .then(res => {
          this.user.status = this.status
          this.$emit('userUpdated') // Lecture 112

          this.$modal.show('status-updated-modal')

          let selector1 = ''
          if (this.user.is_candidate) {
            selector1 = 'Candidate'
          }
          else if (this.user.is_employer) {
            selector1 = 'Employer'
          }

          axios.get(`/api/emailtemplates/?agency=${this.$store.getters.agencyID}&status=${this.status}&type=Status Change Notification&selector1=${selector1}&deactivated=false`) // Get the email template corresponding to the new status
            .then(res => {
              console.log(res)
              if (res.data.length) { // If there is an email template for this new status
                let emailTemplate = res.data[0]

                let agencyEmail = ''
                if (emailTemplate.from_email) {
                  agencyEmail = emailTemplate.from_email
                } else {
                  agencyEmail = this.$store.getters.agencyAdminEmail
                  // if (this.user.is_candidate) {
                  //   agencyEmail = this.$store.getters.agencyAdminEmail3
                  // }
                }
                console.log(agencyEmail)
                // let agencyEmail = this.$store.getters.agencyFromEmail

                console.log(emailTemplate)
                // if (emailTemplate.type == 'Status Change Notification') { // If the email template triggers on
                  this.$store.dispatch('sendEmails', {
                    subject: emailTemplate.subject,
                    message: emailTemplate.body.replace('[[fname]]', this.user.first_name), // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
                    // from: this.$store.getters.agencyFromEmail,
                    from: agencyEmail,
                    emails: [this.$store.getters.enginehireLoggingEmail, this.user.email],
                    // reply: this.$store.getters.agencyReplyEmail,
                    reply: agencyEmail,
                    userID: this.user.id,
                    html: true,
                  })
                // }
              }
            })
            .catch(error => console.log(error))

          // Get any document templates that trigger on a change to this status
          axios.get(`/api/documenttemplates/?agency=${this.$store.getters.agencyID}&status_trigger=${this.status}&type=${selector1}`)
            .then(res => {
              console.log(res)
              let templates = res.data
              for (var template in templates) {
                // axios.get(`/api/documents/?signing_user=${this.user.id}&title=${templates[template].name}`)
                //   .then(res => {
                //     console.log(res)
                //     if (!res.data.length) { // If the document doesn't already exist, we need to create it
                //       // console.log(this.$store.getters.transportationConsent)

                      axios.post('/api/documents/', {
                        template: templates[template].id,
                        title: templates[template].name,
                        signing_user: this.user.id,
                        status: 'Unsigned',
                        // field1: `${this.user.first_name} ${this.user.last_name} & ${this.user.features[0]} ${this.user.features[1]}`,
                        // field2: children,
                        body: templates[template].body,
                        fields_labels: templates[template].fields,
                        fields_required: templates[template].fields_required,
                        edit_access: templates[template].edit_access,
                        organization_signer: templates[template].organization_signer,
                        signer_labels: templates[template].signer_labels,
                        agency_owner: this.$store.getters.agencyName,
                        agency: this.$store.getters.agencyID,
                      })
                        .then(res => { console.log(res) })
                        .catch(error => { console.log(error) })
                  //   }
                  // })
                  // .catch(error => console.log(error))
              }
            })
            .catch(error => console.log(error))
        })
    },
    updatePassword() {
      axios.post('/optimum/manual-reset-password/', {
        user_id: this.user.id,
        password: this.password,
      })
        .then(res => {
          console.log(res)
          this.$modal.show('password-reset-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/agents/Panel.vue